

























































































































































































































































































































import { appModule } from "@/store/modules/app";
import { storeResume } from "@/store/modules/resume";
import { userModule } from "@/store/modules/user";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import storeBilling from "@/store/modules/Billing";
import RegisterKunjunganSvc from "@/services/RegisterKunjungan";
import Billing from "@/services/Billing";
import { storeDokter } from "@/store/modules/dokter";
import AutoCompleteTindakan from "@/components/pemeriksaan/pelayanan/AutoCompleteTindakan.vue";
import AutoCompleteDiagnosa from "@/components/pemeriksaan/pelayanan/AutoCompleteDiagnosa.vue";
import AutoCompleteProsedur from "@/components/pemeriksaan/pelayanan/AutoCompleteProsedur.vue";
import DataPasien from "@/services/DataPasien";
import LockingRegister from "@/utility/LockingRegister";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { storePasien } from "@/store/modules/pasien";
import ModalKonfirmasi from "@/components/modal/KonfirmasiLogout.vue";

@Component({
  components: {
    AutoCompleteTindakan,
    AutoCompleteDiagnosa,
    AutoCompleteProsedur,
    ModalKonfirmasi,
  },
})
export default class CardTindakan extends Vue {
  @Prop() register!: object;
  @Prop() pasien!: object;
  @Prop() dokter!: object;
  @Prop() listDokter!: object[];
  @Prop() disDiag!: boolean;
  @Prop() disTambah!: boolean;
  @Prop() disSaving!: boolean;
  @Prop() from!: string;
  @Prop() jam!: string;
  @Prop() tglIsi!: string;
  @Prop({ default: false }) readOnly!: boolean;
  saving = false;
  batal = false;
  savingDiag = false;
  autofocusCombo = false;
  disBatal = true;
  total = 0;
  totalBilling = 0;
  totalLainnya = 0;
  selectTindakan = {};
  // tglIsi = moment().format("YYYY-MM-DD");
  // jam = moment().format("HHmm");
  autofocusComboDiag = false;
  autofocusComboProc = false;
  rm = null;
  modalOpenKonfirmasi = false;
  msgConfirm = "";
  tindakan = [
    {
      pemeriksaan_id: null,
      pelayanan: null,
      jumlah: null,
      tarif: null,
      dokter: null,
      c_doc_id: null,
      subtotal: null,
    },
  ];
  diagnosa = [
    {
      kode: null,
      nama: null,
      kasus: null,
      tgl: null,
      unit_id: null,
      dr_id: null,
    },
  ];
  prosedur = [
    {
      kode: null,
      nama: null,
      tgl: null,
      unit_id: null,
      dr_id: null,
    },
  ];

  get loading() {
    return storeBilling.loading;
  }
  get stateuser() {
    return userModule.user;
  }
  get hasilTindakan() {
    return storeBilling.hasilTindakan;
  }
  get hasilDiagnosis() {
    return storeBilling.diagnosis;
  }
  get hasilProcedure() {
    return storeBilling.procedure;
  }
  get detailTindakan() {
    return storeBilling.listTindakan;
  }
  get hasilTindakanUnit() {
    let data = storeBilling.hasilTindakan;
    if (data && data.length > 0) {
      data = data.filter((val) => val.unit_id == this.stateuser.unit_id);
    }
    return data;
  }
  get input() {
    const inp = {
      tanggal: this.tglIsi,
      jam: this.jam,
      asr_id: this.register["asr"],
      unit_id: this.stateuser.unit_id,
      c_doc_id: this.dokter["c_doc_id"],
      kelas_id: this.register["kl"],
      rm: this.register["cm"].substr(2, 6),
      register_id: this.register["no"],
      register_tgl: this.formatTgl(this.register["tgl"]),
      pemeriksaan: this.tindakan,
    };
    return inp;
  }
  get inputDiagnosis() {
    const inp = {
      register_id: this.register["no"],
      pasien_rm: this.register["cm"].substr(2, 6),
      diagnosis: this.diagnosa,
    };
    return inp;
  }
  get inputProcedure() {
    const inp = {
      register_id: this.register["no"],
      pasien_rm: this.register["cm"].substr(2, 6),
      procedure: this.prosedur,
    };
    return inp;
  }
  formatTgl(date) {
    const [day, month, year] = date.split("-");
    return year + "-" + month + "-" + day;
  }
  formatjam(jam) {
    return jam ? moment(jam, "HHmm").format("HH:mm") : "";
  }
  addNewItem() {
    const data = {
      pemeriksaan_id: null,
      pelayanan: null,
      jumlah: null,
      tarif: null,
      dokter: null,
      c_doc_id: null,
      subtotal: null,
    };
    this.tindakan.push(data);
    this.autofocusCombo = true;
  }
  removeItem(idx) {
    this.tindakan.splice(idx, 1);
    this.count();
    if (this.tindakan.length == 0) {
      this.addNewItem();
    }
  }
  count() {
    this.total = 0;
    if (this.tindakan.length > 0) {
      for (let i = 0; i < this.tindakan.length; i++) {
        this.tindakan[i].subtotal =
          this.tindakan[i]["jumlah"] * Number(this.tindakan[i]["tarif"]);
        this.total =
          this.total +
          this.tindakan[i]["jumlah"] * Number(this.tindakan[i]["tarif"]);
      }
    }
  }
  currency(val) {
    if (val) {
      return (
        "Rp." +
        Number(val)
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")
      );
    } else {
      return null;
    }
  }
  rupiah(val) {
    if (val) {
      return Number(val)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    } else {
      return null;
    }
  }
  simpanTindakan() {
    if (this.register) {
      if (this.register["dout"] == null) {
        let jum;
        for (let i = 0; i < this.tindakan.length; i++) {
          if (!this.tindakan[i].pemeriksaan_id) {
            this.tindakan.splice(i, 1);
            this.count();
          }
        }
        jum = 0;
        for (let i = 0; i < this.tindakan.length; i++) {
          if (!this.tindakan[i].jumlah) {
            jum = jum + 1;
          }
          if (!this.tindakan[i].c_doc_id) {
            jum = jum + 1;
          }
        }
        if (jum == 0) {
          if (!this.saving) {
            this.saving = true;
            this.disSaving = true;
            const dt = Billing.postPelayanan(this.input);
            dt.then((dt) => {
              this.saving = false;
              this.disSaving = false;
              if (dt["status"] != 1) {
                appModule.sendErrorAlert(dt["message"]);
              } else {
                appModule.NoticeDelay("Berhasil Simpan Tindakan Medik");
                // this.unlockRegister();
                storeBilling.getTindakanbyReg(this.register["no"]);
                // this.batalAkses();
              }
            });
          }
        } else {
          appModule.sendErrorAlert(
            "Pastikan Kolom Jumlah dan Kolom Dokter Terisi"
          );
        }
      } else {
        appModule.sendErrorAlert(
          "Tidak bisa input tindakan! Pasien sudah dipulangkan tanggal " +
            this.register["dout"]
        );
      }
    } else {
      appModule.sendErrorAlert("Silahkan input No RM dahulu");
    }
  }
  simpanDiagnosis() {
    if (this.register) {
      if (
        this.dokter["id"] &&
        this.diagnosa.length > 0 &&
        this.inputProcedure.procedure.length > 0
      ) {
        for (let i = 0; i < this.diagnosa.length; i++) {
          if (!this.diagnosa[i]["kode"]) {
            this.diagnosa.splice(i, 1);
          }
        }
        for (let i = 0; i < this.prosedur.length; i++) {
          if (!this.prosedur[i]["kode"]) {
            this.prosedur.splice(i, 1);
          }
        }
        if (!this.savingDiag) {
          this.savingDiag = true;
          this.disDiag = true;
          const dt = Billing.postDiagnosa(this.inputDiagnosis);
          dt.then((dt) => {
            this.savingDiag = false;
            this.disDiag = false;
            if (dt["status"] != 1) {
              appModule.sendErrorAlert(dt["message"]);
              this.addNewItemDiag();
            } else {
              appModule.NoticeDelay("Berhasil Simpan Diagnosis");
              storeBilling.getDiagnosis(this.register["no"]);
            }
          });
          this.savingDiag = true;
          this.disDiag = true;
          const data = Billing.postProcedure(this.inputProcedure);
          data.then((data) => {
            this.savingDiag = false;
            this.disDiag = false;
            if (data["status"] != 1) {
              appModule.sendErrorAlert(data["message"]);
              this.addNewItemProc();
            } else {
              this.addNewItemProc();
              appModule.NoticeDelay("Berhasil Simpan Prosedur/Tindakan");
              storeBilling.getProcedure(this.register["no"]);
            }
          });
        }
      } else {
        appModule.sendErrorAlert(
          "Pastikan DPJP, Diagnosis & Prosedur/Tindakan Terisi"
        );
      }
    } else {
      appModule.sendErrorAlert("Silahkan input No RM dahulu");
    }
  }
  tglSimpel(val) {
    return val ? moment(val).format("DD/MM") : "";
  }
  addNewItemDiag() {
    const data = {
      kode: null,
      nama: null,
      kasus: null,
      tgl: null,
      unit_id: null,
      dr_id: null,
    };
    this.diagnosa.push(data);
    this.autofocusComboDiag = true;
  }
  removeItemDiag(idx) {
    this.diagnosa.splice(idx, 1);
    if (this.diagnosa.length == 0) {
      this.addNewItemDiag();
    }
  }
  selectedItemDiag(val) {
    this.diagnosa[val.index] = val.diagnosa;
  }
  addNewItemProc() {
    const data = {
      kode: null,
      nama: null,
      tgl: null,
      unit_id: null,
      dr_id: null,
    };
    this.prosedur.push(data);
    this.autofocusComboProc = true;
  }
  removeItemProc(idx) {
    this.prosedur.splice(idx, 1);
    if (this.prosedur.length == 0) {
      this.addNewItemProc();
    }
  }
  selectedItemProc(val) {
    this.prosedur[val.index] = val.prosedur;
  }
  batalAkses() {
    this.rm = null;
    this.register = null;
    this.pasien = null;
    this.dokter = null;
    storeBilling.clearBilling();
    this.total = 0;
    this.totalBilling = 0;
    this.totalLainnya = 0;
    this.disDiag = true;
    this.disSaving = true;
    this.disTambah = true;
  }
  selectedItem(val) {
    this.tindakan[val.index] = val.tindakan;
    this.count();
  }
  konfirmBatalPeriksa() {
    this.modalOpenKonfirmasi = true;
    this.msgConfirm =
      "Anda yakin ingin batal periksa pasien: " +
      this.pasien["rm_dash"] +
      " a/n " +
      this.pasien["nama"];
  }
  batalPeriksa() {
    if (this.register) {
      if (!this.batal) {
        this.batal = true;
        this.disBatal = true;
        const dt = Billing.postBatalPeriksa(this.register["no"]);
        dt.then((dt) => {
          this.batal = false;
          this.disBatal = false;
          if (dt["status"] != 1) {
            appModule.sendErrorAlert(dt["message"]);
          } else {
            appModule.NoticeDelay("Berhasil Batal Periksa");
            this.disBatal = true;
            RegisterKunjungan.getRegister(this.register["no"]);
            this.$emit("batalPeriksa");
          }
        });
      }
    }
  }

  @Watch("hasilDiagnosis")
  changeDiagnosis(val) {
    this.diagnosa = [];
    if (val && val.diagnosis && val.diagnosis.length > 0) {
      this.autofocusComboDiag = false;
      for (let i = 0; i < val.diagnosis.length; i++) {
        const data = {
          kode: val.diagnosis[i].kode,
          nama: val.diagnosis[i].nama,
          kasus: val.diagnosis[i].kasus,
          tgl: val.diagnosis[i].tgl,
          unit_id: val.diagnosis[i].unit_id,
          dr_id: val.diagnosis[i].dr_id,
        };
        this.diagnosa.push(data);
      }
      setTimeout(() => {
        this.addNewItemDiag();
        for (let i = 0; i < this.diagnosa.length; i++) {
          if (!this.diagnosa[i].kode) {
            this.removeItemDiag(i);
          }
        }
        this.autofocusComboDiag = false;
      }, 500);
    } else {
      this.diagnosa = [];
      this.autofocusComboDiag = true;
      this.addNewItemDiag();
    }
  }
  @Watch("hasilProcedure")
  changeProcedure(val) {
    this.prosedur = [];
    if (val && val.procedure && val.procedure.length > 0) {
      this.autofocusComboProc = false;
      for (let i = 0; i < val.procedure.length; i++) {
        const data = {
          kode: val.procedure[i].kode,
          nama: val.procedure[i].nama,
          tgl: val.procedure[i].tgl,
          unit_id: val.procedure[i].unit_id,
          dr_id: val.procedure[i].dr_id,
        };
        this.prosedur.push(data);
      }

      setTimeout(() => {
        this.addNewItemProc();
        for (let i = 0; i < this.prosedur.length; i++) {
          if (!this.prosedur[i].kode) {
            this.removeItemProc(i);
          }
        }
        this.autofocusComboProc = false;
      }, 500);
    } else {
      this.prosedur = [];
      this.autofocusComboProc = true;
      this.addNewItemProc();
    }
  }
  @Watch("hasilTindakan")
  changehasilTindakan() {
    this.totalBilling = 0;
    this.totalLainnya = 0;
    if (this.hasilTindakan && this.hasilTindakan.length > 0) {
      for (let i = 0; i < this.hasilTindakan.length; i++) {
        this.totalBilling =
          this.totalBilling + Number(this.hasilTindakan[i].subtotal);
      }
      const lain = this.hasilTindakan.filter(
        (val) => val.unit_id != this.stateuser.unit_id
      );
      if (lain.length > 0) {
        for (let i = 0; i < lain.length; i++) {
          this.totalLainnya = this.totalLainnya + Number(lain[i].subtotal);
        }
      }
    } else {
      this.totalBilling = 0;
      this.totalLainnya = 0;
    }
    this.changeTotalBilling();
  }
  @Watch("detailTindakan")
  changeDetailTindakan(val) {
    this.tindakan = [];
    if (val && val.length > 0) {
      this.autofocusCombo = false;
      for (let i = 0; i < val.length; i++) {
        const data = {
          pemeriksaan_id: val[i].pemeriksaan.id,
          pelayanan: val[i].pemeriksaan,
          jumlah: val[i].jumlah,
          tarif: Number(val[i].subtotal) / Number(val[i].jumlah),
          dokter: val[i].dokter,
          c_doc_id: val[i].dokter.c_doc_id,
          subtotal: val[i].subtotal,
        };
        this.tindakan.push(data);
      }
      this.count();
      setTimeout(() => {
        this.addNewItem();
        for (let i = 0; i < this.tindakan.length; i++) {
          if (!this.tindakan[i].pemeriksaan_id) {
            this.removeItem(i);
          }
        }
      }, 500);
    } else {
      this.total = 0;
      this.tindakan = [];
      this.autofocusCombo = true;
      this.addNewItem();
    }
  }
  @Watch("totalBilling")
  changeTotalBilling() {
    if (this.totalBilling > 10000) {
      this.disBatal = true;
    } else {
      if (this.register && this.register["dout"] == null) {
        this.disBatal = false;
      } else {
        this.disBatal = true;
      }
    }
  }
}
